module.exports = __webpack_public_path__ + "img/switch1.a49a6d2e.png";